import React from "react";
import { Button } from "./Button.jsx";
import { Icon } from "./Icon.jsx";

/* Clickable button with icon + text — replaces legacy uiComponents/IconTextButton. */

export function IconTextButton({
  icon: IconComponent,
  iconName,
  iconProps,
  iconPosition = "left",
  buttonText,
  variant = "ghost",
  onClick,
  disabled,
  style,
  type = "button",
  ...rest
}) {
  const iconNode = IconComponent ? (
    <IconComponent style={{ width: 20, height: 20, ...iconProps }} />
  ) : iconName ? (
    <Icon name={iconName} size={20} style={iconProps} />
  ) : null;

  return (
    <Button
      type={type}
      variant={variant === "text" ? "ghost" : variant === "outlined" ? "outline" : variant}
      size="sm"
      onClick={onClick}
      disabled={disabled}
      style={{ padding: "5px 8px", minWidth: 0, gap: 6, ...style }}
      {...rest}
    >
      {iconPosition === "left" && iconNode}
      {buttonText}
      {iconPosition === "right" && iconNode}
    </Button>
  );
}

export default IconTextButton;
